import { Tabs } from "antd";
import PurchaseReturnEntry from "./Purchase Return Entry/PurchaseReturnEntry";
import PurchaseReturnRecord from "./PurchaseReturnRecord";
import PurchaseReturnVoucher from "./PurchaseReturnVoucher";
import { useLocation, useNavigate } from "react-router-dom";
import { accessChecker, pathSpliter } from "../../../lib/functions";


const PurchaseReturn = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const pur_r_id = pathSpliter(location.pathname, 2)
  ? pathSpliter(location.pathname, 2)
  : null;

  const navigate = useNavigate();

  const menuData = [
    {
      label: "Purchase Return Entry",
      key: "entry",
      value: "purchase_return",
      children: (
        <>
          <PurchaseReturnEntry />
        </>
      ),
    },
    {
      label: "Purchase Return Record",
      key: "record",
      value: "purchase_return_record",
      children: (
        <>
          <PurchaseReturnRecord />
        </>
      ),
    },
    {
      label: "Purchase Return Voucher",
      key: "voucher",
      value: "purchase_return_voucher",
      children: (
        <>
          <PurchaseReturnVoucher />
        </>
      ),
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      activeKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      onChange={(key) => {
    if (key === "entry" && pur_r_id) {
      navigate(`/purchase-return/${pur_r_id}?tab=entry`);
      } else {
        navigate(`/purchase-return?tab=${key}`);
      }
    }}
      items={filteredMenuData}
    />
  );
};

export default PurchaseReturn;
